var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconToday(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "40px",
    height: "40px",
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 2 Copy@3x") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Log-in",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2-Copy"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy",
    fill: "#264FAE",
    x: 0,
    y: 0,
    width: 40,
    height: 40,
    rx: 4
  }), /*#__PURE__*/React.createElement("g", {
    id: "Icon/Calendar/Filled",
    transform: "translate(8.000000, 8.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Base",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.5,20.125 C3.5,21.1601562 4.31584821,22 5.32142857,22 L18.6785714,22 C19.6841518,22 20.5,21.1601562 20.5,20.125 L20.5,9.5 L3.5,9.5 L3.5,20.125 Z M5.92857143,12.625 C5.92857143,12.28125 6.20178571,12 6.53571429,12 L10.1785714,12 C10.5125,12 10.7857143,12.28125 10.7857143,12.625 L10.7857143,16.375 C10.7857143,16.71875 10.5125,17 10.1785714,17 L6.53571429,17 C6.20178571,17 5.92857143,16.71875 5.92857143,16.375 L5.92857143,12.625 Z M18.6785714,4.5 L16.8571429,4.5 L16.8571429,2.625 C16.8571429,2.28125 16.5839286,2 16.25,2 L15.0357143,2 C14.7017857,2 14.4285714,2.28125 14.4285714,2.625 L14.4285714,4.5 L9.57142857,4.5 L9.57142857,2.625 C9.57142857,2.28125 9.29821429,2 8.96428571,2 L7.75,2 C7.41607143,2 7.14285714,2.28125 7.14285714,2.625 L7.14285714,4.5 L5.32142857,4.5 C4.31584821,4.5 3.5,5.33984375 3.5,6.375 L3.5,8.25 L20.5,8.25 L20.5,6.375 C20.5,5.33984375 19.6841518,4.5 18.6785714,4.5 Z",
    id: "Icon",
    fill: "#FFFFFF"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconToday);
export default __webpack_public_path__ + "static/media/icon-today.316856b2.svg";
export { ForwardRef as ReactComponent };